/**
 * 代理商
 */
// agent("代理商"),
// //子客
// sub("子客"),
// //优化师
// worker_optimizer("优化师"),
// //财务
// worker_finance("财务"),
// //销售
// worker_saler("销售"),
// //其他协作者
// worker_other("其他协作者"),
// ;

import React from "react"
import {
  createFromIconfontCN, TeamOutlined, PicLeftOutlined,
  FundOutlined, IdcardOutlined, CreditCardOutlined, BarChartOutlined, PushpinOutlined, StockOutlined,
  ToolOutlined, HeatMapOutlined, BookOutlined, RadarChartOutlined,
  TableOutlined
} from "@ant-design/icons"

// 角色类型定义
export type RoleType = 'agent' | 'sub' | 'worker_optimizer' | 'worker_finance' | 'worker_saler' | 'worker_other' | 'newaccount';

// 登录信息类型定义
export interface LoginInfo {
  role?: RoleType;
  openNewBp?: boolean;
  finance?: boolean;
  compensateSwitch?: boolean;
  compensateV2Switch?: boolean;
  dmpV1?: boolean;
  openLibrary?: boolean;
  diagnosis?: boolean;
  mapiWhiteUser?: boolean;
  coldBootSwitch?: boolean;
  [key: string]: any;
}

// 菜单项类型定义
export interface MenuItem {
  key: string;
  title: string | JSX.Element;
  link?: string;
  code?: string;
  authCode?: RoleType[];
  icon?: (() => JSX.Element) | null;
  children?: MenuItem[];
  hidden?: boolean;
  greyTitle?: string;
  showGreyTitle?: (logininfo: LoginInfo) => boolean;
  grey?: (logininfo: LoginInfo) => boolean;
  isBlank?: boolean;
  isNew?: boolean;
}

// 环境配置
const ENV = {
  PRE: 'pre',
  PROD: 'prod'
} as const;

export type EnvType = keyof typeof ENV;

const env = (window as any).pageVars.app.env || ENV.PROD;

// DMP URL配置
const DMP_URL = {
  [ENV.PRE]: 'https://pre-ad-dmp.youku.com',
  [ENV.PROD]: 'https://ad-dmp.youku.com'
} as const;

// 自定义图标配置
const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/a/font_2455017_qzef1kn6sp.js",
});

// 权限常量
const AUTH = {
  AGENT: ["agent"] as RoleType[],
  AGENT_WORKER: ["agent", "worker_optimizer", "worker_saler", "worker_other"] as RoleType[],
  ALL: ["agent", "worker_optimizer", "worker_finance", "worker_saler", "worker_other"] as RoleType[],
  AGENT_FINANCE_OTHER: ["agent", "worker_finance", "worker_other"] as RoleType[],
  AGENT_OPTIMIZER_OTHER: ["agent", "worker_optimizer", "worker_other"] as RoleType[],
  AGENT_OPTIMIZER: ["agent", "worker_optimizer"] as RoleType[],
  AGENT_NEW_ACCOUNT: ["agent", "newaccount"] as RoleType[],
  AGENT_NEW_OPTIMIZER_ACCOUNT: ["agent", "worker_optimizer", 'newaccount'] as RoleType[],
} as const;

// 改进isGrey函数逻辑，使用类型断言确保返回布尔值
const isGrey = (condition: string) => (logininfo: LoginInfo): boolean => {
  if (!logininfo || !condition) return false;
  const key = condition.startsWith('!') ? condition.slice(1) : condition;
  const hasKey = Object.prototype.hasOwnProperty.call(logininfo, key);
  const value = hasKey ? Boolean(logininfo[key as keyof LoginInfo]) : false;
  return condition.startsWith('!') ? !value : value;
};

// 创建图标组件的工厂函数
const createIcon = (Icon: React.ComponentType<any>, size = 20) =>
  () => <Icon style={{ fontSize: size }} />;

const data: MenuItem[] = [
  {
    key: "index",
    title: "首页",
    link: "/index",
    code: "index",
    authCode: AUTH.AGENT_WORKER,
  },
  {
    key: "custom",
    title: "客户",
    code: "custom",
    authCode: AUTH.AGENT_NEW_OPTIMIZER_ACCOUNT,
    children: [
      {
        key: "6302",
        title: "客户管理",
        authCode: AUTH.AGENT_WORKER,
        icon: createIcon(TeamOutlined, 16),
        children: [
          {
            key: "6303",
            title: "客户列表",
            link: "/customerList",
            authCode: AUTH.AGENT_WORKER
          },
          {
            key: "promotionlist",
            title: "推广管理",
            link: "/promotionlist",
            authCode: AUTH.AGENT_WORKER
          },
        ],
      },
      {
        key: "6305",
        title: "账号管理",
        authCode: AUTH.AGENT,
        icon: createIcon(IdcardOutlined, 16),
        children: [

          {
            key: "addAccounts",
            title: "添加账号和资金分配",
            link: "/addAccounts",
            authCode: AUTH.AGENT,
          },
          {
            key: "allocateFunds",
            title: "分配资金额度",
            link: "/allocateFunds",
            hidden: true,
            authCode: AUTH.AGENT,
          },
          {
            key: "7ee8c731",
            title: "分配资金额度",
            link: "/7ee8c731",
            hidden: true,
            authCode: AUTH.AGENT,
          },
          {
            key: "rengzhengzhongxin",
            title: "认证中心",
            link: "/e1fed46b",
            hidden: true,
            authCode: AUTH.AGENT,
            grey: (logininfo) => {
              return !logininfo.advertiserAuditWhiteUser
            }
          },
          {
            key: "subAdvertiserInfo",
            title: "认证中心(新)",
            link: "/subAdvertiserInfo",
            hidden: true,
            authCode: AUTH.AGENT,
            grey: (logininfo) => {
              return logininfo.advertiserAuditWhiteUser
            }
            
          },
          {
            key: "6427",
            title: "协作账号管理",
            link: "/collaborateAccount",
            authCode: AUTH.AGENT,
          },
          {
            key: "6431",
            title: "帐户信息",
            icon: null,
            link: "/accountInfo",
            authCode: AUTH.AGENT_NEW_ACCOUNT,
          },
        ],
      },
    ],
  },
  {
    key: "data",
    title: "数据",
    code: "data",
    authCode: AUTH.ALL,
    children: [
      {
        key: "6424",
        title: "账号报表",
        icon: () => <CreditCardOutlined size={20} />,
        children: [
          {
            key: "/0d5bb31d",
            title: "代理商帐户",
            link: "/0d5bb31d",
            authCode: AUTH.AGENT,
          },
          {
            key: "605ca278",
            title: "子客帐户",
            link: "/605ca278",
            authCode: AUTH.ALL,
          },
        ],
      },
      {
        key: "6434",
        title: "投放报表",
        authCode: AUTH.ALL,
        icon: () => <BarChartOutlined size={20} />,
        children: [
          {
            key: "projectReport",
            title: "项目报表",
            link: "/projectReport",
            authCode: AUTH.ALL,
          },
          {
            key: "adReport",
            title: "广告报表",
            link: "/adReport",
            authCode: AUTH.ALL,
          },
          {
            key: "creativeReport",
            title: "创意报表",
            link: "/creativeReport",
            authCode: AUTH.ALL,
          },

        ],
      },
      {
        key: "crowdAnalysis",
        title: <div><RadarChartOutlined size={20} />&nbsp;&nbsp;人群分析报表</div>,
        link: "/crowdAnalysis",
        authCode: AUTH.ALL
      },
      {
        key: "productLibReport",
        title: <div><TableOutlined size={20} />&nbsp;&nbsp;产品库报表</div>,
        link: "/productLibReport",
        authCode: AUTH.ALL,
        grey: (logininfo) => {
          return logininfo?.productLibCrmSwitch
        },
      },
      {
        key: "materialReport",
        title: <div><StockOutlined size={20} />&nbsp;&nbsp;素材报表</div>,
        link: "/materialReport",
        authCode: AUTH.ALL
      },
      {
        key: "specialReport",
        title: "专项报告",
        icon: () => <BookOutlined size={20} />,
        authCode: AUTH.ALL,
        children: [
          {
            key: "kuWorryFreeReport",
            title: 'oCPX成本保障报告',
            link: "/kuWorryFreeReport",
            authCode: AUTH.ALL
          },
          {
            key: "boostAppointReport",
            title: "一键起量报告",
            link: "/boostAppointReport",
            authCode: AUTH.ALL
          }
        ]
      },
    ],
  },
  {
    key: "finance",
    title: "财务",
    code: "finance",
    authCode: AUTH.AGENT_FINANCE_OTHER,
    children: [
      {
        key: "6438",
        title: "财务流水",
        link: "/553b757c",
        authCode: AUTH.AGENT_FINANCE_OTHER
      },
      {
        key: "accountRecharge",
        title: "账户充值",
        link: "/accountRecharge",
        authCode: AUTH.AGENT_FINANCE_OTHER,
      },
    ],
  },
  {
    key: "assets",
    title: "资产",
    code: "assets",
    authCode: AUTH.AGENT_OPTIMIZER_OTHER,
    children: [
      {
        key: "6440",
        title: "定向",
        authCode: AUTH.AGENT_OPTIMIZER_OTHER,
        icon: () => <PushpinOutlined size={20} />,
        children: [

          {
            key: "dmpsite",
            title: 'DMP平台',
            link: DMP_URL[env],
            isBlank: true,
            isNew: true,
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
          },
        ],
      },
      {
        key: "6485",
        title: "素材管理",
        icon: () => <PicLeftOutlined size={20} />,
        authCode: AUTH.AGENT_OPTIMIZER_OTHER,
        children: [
          {
            key: "materialManagement",
            title: "素材授权",
            link: "/materialManagement",
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
          },
          {
            key: "6486",
            title: "自建站",
            link: "/601e1bdb",
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
          },
          {
            key: "sitedata",
            title: "自建站数据",
            link: "/73cbfb8f",
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
            hidden: true,
          },
          {
            key: "selfWebData",
            title: "自建站数据(新)",
            link: "/selfWebData",
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
            hidden: true,
          },

        ],
      },
      {
        key: "产品库管理",
        title: "产品库管理",
        icon: () => <CreditCardOutlined size={20} />,
        authCode: AUTH.AGENT_OPTIMIZER_OTHER,
        grey: (logininfo) => {
          return logininfo?.productLibCrmSwitch
        },
        children: [
          {
            key: "productLibAuthorize",
            title: "产品库授权",
            link: "/productLibAuthorize",
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
            grey: (logininfo) => {
              return logininfo?.productLibCrmSwitch
            },
          },
        ],
      },
      {
        key: "6444",
        title: "转化",
        icon: () => <IconFont type="icon-tubiao" size={20} />,
        authCode: AUTH.AGENT_OPTIMIZER_OTHER,
        children: [
          {
            key: "6445",
            title: "转化追踪",
            link: "/493255ca",
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
          },
          {
            key: "zhuanhuazhuizong",
            title: "转化追踪新建/编辑",
            link: "/v2/8dd949ac",
            hidden: true,
          },
        ],
      },
    ],
  },
  {
    key: "tools",
    title: "工具",
    code: "tools",
    authCode: AUTH.AGENT_OPTIMIZER_OTHER,
    children: [
      {
        key: "platformtool",
        title: "平台工具",
        authCode: AUTH.AGENT,
        icon: () => <ToolOutlined size={20} />,
        grey: isGrey('mapiWhiteUser'),
        children: [
          {
            key: "mapi",
            title: "授权管理",
            link: "/authorizeManagement",
            authCode: AUTH.AGENT,
            grey: isGrey('mapiWhiteUser'),
          },
        ],
      },
      {
        key: "6442",
        title: "流量工具",
        icon: () => <FundOutlined size={20} />,
        authCode: AUTH.AGENT_OPTIMIZER_OTHER,
        children: [
          {
            key: "6443",
            title: "RTA策略管理",
            link: "/45df9d7c",
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
          },
        ],
      },
      {
        key: "accouttool",
        title: "账户工具",
        icon: () => <IdcardOutlined size={20} />,
        authCode: AUTH.ALL,
        children: [
          {
            key: "downloadtask",
            title: "下载任务",
            link: "/downloadTask",
            authCode: AUTH.ALL,
          },
          {
            key: "operationLog",
            title: "操作日志",
            link: "/operationLog",
            authCode: AUTH.AGENT_OPTIMIZER_OTHER,
            grey: (logininfo) => {
              return logininfo?.oplogSwitch
            },
          },
        ],
      },
      {
        key: "putingtool",
        title: "投放工具",
        icon: () => <HeatMapOutlined size={20} />,
        authCode: AUTH.AGENT_OPTIMIZER,
        children: [
          {
            key: "accountanalysis",
            title: "账户投放分析",
            link: "/accountAnalysis",
            authCode: AUTH.AGENT_OPTIMIZER,
          },
        ],
      },
    ],
  },
]

export default data
